export type StudyPeriodConfig = {
  getNumberOfDaysByUnit(unit: 'MONTH'): number;
  inactivityThresholdInDays: number;
  enabled: boolean;
};

export const StudyPeriodConfig = {
  DEFAULT_DAYS_IN_MONTH: 30,
  DEFAULT_INACTIVITY_THRESHOLD_IN_DAYS: 7,
};
